import { Box, BoxProps, Text } from 'grommet';
import { Document } from 'lib/api';
import { DocumentLink } from '../project-home/DocumentLink';
import { RightInfoCard } from './RightInfoCard';

export type AttachedDocumentProps = {
  background?: BoxProps['background'];
  document: Document;
};

export const AttachedDocument = ({ background, document }: AttachedDocumentProps) => {
  return (
    <RightInfoCard title="Attached Document" background={background}>
      <Box direction="row" pad="small" gap="small">
        <DocumentLink doc={document} />
        <Text>{document.name}</Text>
      </Box>
    </RightInfoCard>
  );
};
